import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';
import { t } from '@/data/translations';
import { Menu, X } from 'lucide-react';

export default function Navbar({ onBrochureClick }) {
  const { lang, toggleLang } = useLanguage();
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);
  const nav = t.nav[lang];

  const links = [
    { to: '/', label: nav.home },
    { to: '/portfolio', label: nav.portfolio },
    { to: '/contact', label: nav.contact },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <>
      <nav
        data-testid="main-navbar"
        className="fixed top-0 left-0 right-0 z-50 transition-all duration-700"
        style={{ background: 'rgba(10,10,10,0.4)', backdropFilter: 'blur(20px)', WebkitBackdropFilter: 'blur(20px)' }}
      >
        <div className="max-w-[1400px] mx-auto flex items-center justify-between px-6 md:px-12 py-4">
          <Link to="/" data-testid="nav-logo" className="hover:opacity-80 transition-opacity duration-500">
            <img src="/logo-nav.png" alt="Gemini 1308" className="h-7 md:h-9 w-auto object-contain" />
          </Link>

          <div className="hidden md:flex items-center gap-10">
            {links.map(l => (
              <Link
                key={l.to}
                to={l.to}
                data-testid={`nav-${l.label.toLowerCase()}`}
                className={`text-xs uppercase tracking-[0.15em] font-sans transition-colors duration-500 ${
                  isActive(l.to) ? 'text-gold-muted' : 'text-alpine-mist/70 hover:text-alpine-mist'
                }`}
              >
                {l.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-6">
            <button
              data-testid="lang-toggle"
              onClick={toggleLang}
              className="text-xs uppercase tracking-[0.15em] text-alpine-mist/60 hover:text-gold-muted transition-colors duration-500 font-sans"
            >
              {lang === 'fr' ? 'EN' : 'FR'}
            </button>
            <button
              data-testid="nav-inquire-btn"
              onClick={onBrochureClick}
              className="cta-luxury text-[0.65rem] py-2.5 px-6"
            >
              {nav.brochure}
            </button>
          </div>

          <button
            data-testid="mobile-menu-btn"
            onClick={() => setMobileOpen(true)}
            className="md:hidden text-alpine-mist"
          >
            <Menu size={22} />
          </button>
        </div>
      </nav>

      {mobileOpen && (
        <div className="mobile-nav-overlay" data-testid="mobile-nav-overlay">
          <button
            data-testid="mobile-close-btn"
            onClick={() => setMobileOpen(false)}
            className="absolute top-5 right-6 text-alpine-mist"
          >
            <X size={24} />
          </button>
          {links.map(l => (
            <Link
              key={l.to}
              to={l.to}
              onClick={() => setMobileOpen(false)}
              className="text-xl font-serif text-alpine-mist/80 hover:text-gold-muted transition-colors"
            >
              {l.label}
            </Link>
          ))}
          <button
            onClick={() => { toggleLang(); setMobileOpen(false); }}
            className="text-sm uppercase tracking-[0.2em] text-alpine-mist/50 hover:text-gold-muted transition-colors"
          >
            {lang === 'fr' ? 'English' : 'Francais'}
          </button>
          <button
            onClick={() => { onBrochureClick(); setMobileOpen(false); }}
            className="cta-luxury mt-4"
          >
            {nav.brochure}
          </button>
        </div>
      )}
    </>
  );
}
